import { AxiosResponse } from "axios";

import $api from "../http";

export default class BannersLinkRewriterService {
    static async rewriteBannersLink(link:string): Promise<AxiosResponse> {
        return $api.post("/banner/changeAllBannerLink", {link});
    }
}